import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ShieldAlert, LogOut } from "lucide-react";

const ROLE_LABELS = {
  tenant_admin:    "Admin de Tenant",
  sales:           "Sales",
  broker:          "Broker",
  external_broker: "Broker Externo",
  viewer:          "Viewer",
  editor:          "Editor",
  admin:           "Admin",
  reseller:        "Reseller",
};

export function ImpersonationBanner() {
  const { user, impersonating, exitImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonating || !user) return null;

  const roleLabel = ROLE_LABELS[user.role] || user.role;

  const handleExit = () => {
    exitImpersonation();
    setTimeout(() => navigate("/admin/users"), 0);
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between gap-2"
      style={{
        background: "linear-gradient(90deg, #b45309 0%, #d97706 100%)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
        boxShadow: "0 2px 12px rgba(180,83,9,0.5)",
        // Respect iPhone notch/safe area
        paddingTop: "calc(env(safe-area-inset-top, 0px) + 6px)",
        paddingBottom: "6px",
        paddingLeft:  "clamp(12px, 4vw, 20px)",
        paddingRight: "clamp(12px, 4vw, 20px)",
        minHeight: "38px",
      }}
      data-testid="impersonation-banner"
    >
      {/* Icon + text */}
      <div className="flex items-center gap-1.5 min-w-0">
        <ShieldAlert className="w-3.5 h-3.5 text-white flex-shrink-0" />
        <p className="text-xs text-white font-medium leading-tight truncate">
          {/* Desktop: full label */}
          <span className="hidden sm:inline">
            Modo Admin —{" "}
            <span className="font-bold">{user.email}</span>
            <span className="opacity-70 font-normal ml-1.5">({roleLabel})</span>
          </span>
          {/* Mobile: compact */}
          <span className="sm:hidden">
            Viewing as <span className="font-bold">{user.name || user.email}</span>
          </span>
        </p>
      </div>

      {/* Exit button */}
      <button
        onClick={handleExit}
        className="flex items-center gap-1 flex-shrink-0 bg-white/15 hover:bg-white/25 border border-white/30 text-white text-xs font-semibold rounded-full transition-all"
        style={{ padding: "4px clamp(8px, 3vw, 12px)" }}
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="w-3 h-3 flex-shrink-0" />
        <span className="hidden sm:inline">Volver al Admin</span>
        <span className="sm:hidden">Exit</span>
      </button>
    </div>
  );
}
